import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios';
import {api_base_url, base_url} from '../common/Constants';
 


 
class PopularProducts extends React.Component{

    constructor(props){
        super(props); 
    }
 
    render()
    { 
      
    return (
         <div class="ul-container">
            <div class="ul-breadcrumb">
                <h2 class="ul-breadcrumb-title">{this.props.title}</h2>
                <div class="ul-breadcrumb-nav">
                    <Link to="/"><i class="flaticon-home"></i> Home</Link>
                    <i class="flaticon-arrow-point-to-right"></i>
                    <span class="current-page">{this.props.title}</span>
                </div>
            </div>
        </div>
       

    );
}

}

export default PopularProducts;